import React from "react";
import {
  FORMS_ENABLED,
  FORM_LINK_UNAVAILABLE_NOTE,
} from "../consts/features";

// Link to a form page. While forms are disabled it renders a greyed out,
// unclickable button with a short note instead.
const FormLink = ({ href, className, children }) => {
  if (FORMS_ENABLED) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    );
  }

  return (
    <span className="form-link-unavailable">
      <button
        type="button"
        className={`${className || ""} btn-unavailable`}
        disabled
        aria-disabled="true"
      >
        {children}
      </button>
      <small className="unavailable-note">{FORM_LINK_UNAVAILABLE_NOTE}</small>
    </span>
  );
};

export default FormLink;
